import { render, staticRenderFns } from "./getFortunellaVenosaRule.vue?vue&type=template&id=29972e81&scoped=true&"
import script from "./getFortunellaVenosaRule.vue?vue&type=script&lang=js&"
export * from "./getFortunellaVenosaRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29972e81",
  null
  
)

component.options.__file = "getFortunellaVenosaRule.vue"
export default component.exports